// SPDX-License-Identifier: AGPL-3.0-or-later

import {MatureContentGateReason} from '@app/features/guild/state/GuildMatureContentAgree';

interface MatureMediaResult {
	shouldBlur: boolean;
	shouldBlock: boolean;
	gateReason: MatureContentGateReason;
	canReveal: boolean;
	reveal: () => void;
}

export function useMatureMedia(mature: boolean | undefined, _channelId: string | undefined): MatureMediaResult {
	return {
		shouldBlur: false,
		gateReason: MatureContentGateReason.NONE,
		shouldBlock: mature === true,
		canReveal: false,
		reveal: () => undefined,
	};
}
